"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFrontend = void 0;
const JSONParser_1 = require("lincd-jsonld/lib/utils/JSONParser");
const JSONLD_1 = require("lincd-jsonld/lib/utils/JSONLD");
const RequestData_1 = require("./RequestData");
const LinkedStorage_1 = require("lincd/lib/utils/LinkedStorage");
function initFrontend() {
    var _a;
    //parse incoming data, put it into the default storage graph (so that if we change this data the changes will be pushed back to the store it came from)
    return Promise.all([
        JSONParser_1.JSONParser.parse(document.getElementById('request-json').innerText, LinkedStorage_1.LinkedStorage.getDefaultStorageGraph()),
        JSONLD_1.JSONLD.parseString((_a = document.getElementById('request-ld')) === null || _a === void 0 ? void 0 : _a.innerText, true, null, LinkedStorage_1.LinkedStorage.getDefaultStorageGraph()),
    ]).then(([parseResult]) => {
        (0, RequestData_1.setRequestData)(parseResult);
    });
}
exports.initFrontend = initFrontend;
//# sourceMappingURL=Frontend.js.map